import React, { useEffect, useRef, useState } from 'react'
import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap';
import logoCenec from '../assets/cenec_2.svg';
import logoChorotega from '../assets/chorotega_2.svg';
import { useFormContext } from 'react-hook-form';
import SignatureCanvas from 'react-signature-canvas';

export const SlideFour = ({ formData }) => {
    const { register, setValue, watch, formState: { errors } } = useFormContext();
    const today = new Date().toLocaleDateString();
    const signatureBase64 = watch("signatureBase64"); // Recupera el valor guardado de la firma

    const sigCanvas = useRef(null); // Referencia para el canvas de firma

    useEffect(() => {
        // const signatureBase64 = watch("signatureBase64");
        if (signatureBase64 && sigCanvas.current) {
            const img = new Image();
            img.src = signatureBase64;
            img.onload = () => {
                sigCanvas.current.clear();
                sigCanvas.current.getCanvas().width = sigCanvas.current.getCanvas().parentNode.offsetWidth;
                sigCanvas.current.getCanvas().height = 300;
                sigCanvas.current.fromDataURL(signatureBase64);
            };
        }
    }, [signatureBase64]);

    // Función para borrar la firma
    const clearSignature = () => {
        sigCanvas.current.clear();
    };

    const saveSignature = () => {
        const signatureData = sigCanvas.current.getTrimmedCanvas().toDataURL('image/png');

        setValue("signatureBase64", signatureData);

        const byteString = atob(signatureData.split(',')[1]);
        const mimeString = signatureData.split(',')[0].split(':')[1].split(';')[0];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([ab], { type: mimeString });

        const identity = formData.identity

        // Crea un archivo usando el Blob
        const file = new File([blob], `${identity}_signature.png`, { type: mimeString });

        // Guarda el archivo en el estado del formulario (react-hook-form)
        setValue("signature", file); // Guarda la firma en el formulario
    };

    return (

    <Container className='' style={{ maxWidth: '1200px' }}>
        <div className='d-flex justify-content-center mb-3 ms-2 me-2'>
            <Card className='card-custom-style'>
                <Card.Header className='white-bg-color'>
                    <Row className='justify-content-center'>
                        <Col md={10}>
                            <Row className='justify-content-center cenec-bg-color-v2 mx-1 p-3 rounded-1 mb-3 mt-3'>
                                <Col xl={5} md={5} sm={5} xs={12} className='order-last order-sm-first order-md-first' >
                                    <div className='d-flex justify-content-center align-items-center'>
                                        <img src={logoCenec} alt="Logo CENEC" className='img-cenec'/>
                                    </div>
                                </Col>
                                <Col xl={2} md={2} sm={2} className='d-none d-sm-block text-center'>
                                    <div className='vl'></div>
                                </Col>
                                <Col xs={12} className='d-block d-sm-none'>
                                    <div className='hl'></div>
                                </Col>
                                <Col xl={5} md={5} sm={5} xs={12} className='order-first order-sm-last order-md-last' >
                                    <div className='d-flex justify-content-center align-items-center'>
                                        <img src={logoChorotega} alt="Logo Cooperativa Chorotega" className='img-owner' />
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card.Header>
                <Card.Body>
                    <Form >
                        <Row className='justify-content-center'>
                            <Col md="10" className='mt-3 mb-5'>
                                <h2 className='fs-5 text-center fw-bold'>CONTRATO CON EL AFILIADO</h2>
                            </Col>
                            <div className="w-100"></div>

                            <Col md='10' sm='12' xs='12' className=' mb-3'>
                                <p className='fs-5' style={{ textAlign: 'justify' }}>
                                    <span className="flex-line">
                                        Yo <span className="underline fw-bold text-center">{formData.fullname}</span>
                                    </span>
                                </p>
                                <p className='fs-5' style={{ textAlign: 'justify' }}>
                                    Con identidad <span className="underline fw-bold text-center">{formData.identity}</span> acepto los terminos de este contrato, dando por inicio a la relación a partir de la fecha actual de firma.
                                </p>
                            </Col>

                            <Col md='10' sm='12' xs='12' className='mb-3'>
                                <Form.Label className='fs-5'>Firmar (por favor dibujar su firma en el cuadro de abajo):</Form.Label>
                                <div className="signature-container">
                                    <SignatureCanvas
                                        ref={sigCanvas}
                                        penColor="black"
                                        name="signature"
                                        canvasProps={{
                                            className: 'sigCanvas'
                                        }}
                                    />
                                    <input type="hidden" {...register("signature")} />
                                    {errors.signature && (
                                        <p className="text-danger">
                                            {errors.signature.message}
                                        </p>
                                    )}
                                </div>
                                <div className="mt-2">
                                    <Button variant="secondary" onClick={clearSignature} className="me-2">Borrar</Button>
                                    <Button variant="primary" onClick={saveSignature}>Guardar Firma</Button>
                                </div>
                            </Col>

                            <Col md='10' sm='12' xs='12' className='mb-3'>
                                <p className='fs-5' style={{ textAlign: 'justify' }}>
                                    Lugar y Fecha: <span className='fw-bold'>{today} {formData.state_name}, {formData.town_name}</span>
                                </p>
                            </Col>


                        </Row>
                    </Form>
                </Card.Body>
            </Card>
        </div>
    </Container>
    )
};